import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { videos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function FeaturedVideos() {
  const { t } = useTranslation();
  const featuredVideos = videos.filter((v) => v.featured).slice(0, 6);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              {t('home.featuredTitle')}
            </h2>
            <p className="mt-1 text-sm text-foreground-500">编辑精选的高品质视频内容</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            {t('home.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
          {featuredVideos.map((video) => (
            <VideoCard key={video.id} video={video} size="medium" />
          ))}
        </div>
      </div>
    </section>
  );
}